import { render, staticRenderFns } from "./image-item-field.vue?vue&type=template&id=4f29ae60&"
import script from "./image-item-field.vue?vue&type=script&lang=js&"
export * from "./image-item-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports